import { Link } from "react-router-dom";
import { ArrowRight, Repeat } from "lucide-react";
import { useRecurring } from "@/components/finance/RecurringCard";
import { useFormat } from "@/lib/format";

export const RecurringReminder = () => {
  const { money, date } = useFormat();
  const { data } = useRecurring("personal");
  if (!data?.totals.count) return null;
  const t = data.totals;
  return (
    <Link to="/finances?tab=perso#recurring" className="card-surface tone-wash tone-peach group flex flex-wrap items-center gap-3 p-4 transition-transform hover:-translate-y-0.5" data-testid="dashboard-recurring-reminder">
      <span className="tone-chip flex h-9 w-9 shrink-0 items-center justify-center rounded-xl"><Repeat className="h-4 w-4" /></span>
      <div className="min-w-0 flex-1 text-sm">
        <div className="font-semibold">{t.count} charges récurrentes · <span className="num">{money(t.monthly, { maximumFractionDigits: 0 })}</span>/mois</div>
        <div className="text-xs text-muted-foreground">
          {t.savings_monthly > 0 && <span className="font-semibold text-success" data-testid="dashboard-recurring-savings">Économie possible {money(t.savings_monthly, { maximumFractionDigits: 0 })}/mois · </span>}
          {data.next && `Prochain : ${data.next.name} le ${date(data.next.next_date)}`}
        </div>
      </div>
      <ArrowRight className="h-4 w-4 text-muted-foreground transition-transform group-hover:translate-x-1" />
    </Link>
  );
};
